 
<!-- main app container -->

<app-navbar *ngIf="user"></app-navbar>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
